<div class="parent-menu" (mouseleave)="showMenu = false" (mouseover)="showMenu = true" [ngStyle]="customStyle">
  <a [class]="menuLabelClass">{{ menuLabel }}</a>

  @if (showMenu) {
    <div class="zs-menu">
      <ul>
        @for (menu of menuList; track menu) {
          <li>
            <a (click)="handleMenuClick(menu.value)" class="zs-link-action">
              <span [ngClass]="menu.class"></span>
              <span>{{ menu.value }}</span>
            </a>
          </li>
        }
      </ul>
    </div>
  }
</div>